import React from 'react';
import { formatDate } from '../utils';

const Footer = ({ ticket = null }) => {
  const appVersion = import.meta.env.VITE_VERSION;

  return (
    <div className="mt-auto">
      {/* Ticket Footer Section - Only show when ticket data is available */}
      {ticket && (
        <div className="mt-6 pt-6 border-t-2 border-blue-500/10 flex justify-between items-center flex-wrap gap-4 mb-6">
          <p className="text-slate-600 font-poppins font-medium text-sm">
            📅 Last updated: {formatDate(ticket.updatedAt)}
          </p>
          <div className="bg-blue-500/8 text-blue-600 px-4 py-2 rounded-full border border-blue-500/20 font-poppins font-semibold text-sm">
            ⏰ Ticket Age: {Math.ceil((new Date() - new Date(ticket.createdAt)) / (1000 * 60 * 60 * 24))} days
          </div>
        </div>
      )}

      {/* Help Section */}
      <div className="mt-6 text-center p-6 rounded-lg bg-white/70 backdrop-blur-md">
        <p className="flex items-center justify-center gap-2 flex-wrap mb-4 text-slate-600 text-sm font-poppins">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
          </svg>
          Having trouble with your ticket ID? The new format looks like TK-1F4D89Z7
        </p>
        <p className="flex items-center justify-center gap-2 text-slate-600 text-sm font-poppins">
          Need help? Contact our support team at
          <a 
            href="mailto:icts.imus@deped.gov.ph"
            className="text-black font-medium hover:underline transition-colors"
          >
            icts. proactively@deped.gov.ph
          </a>
        </p>
      </div>

      {/* Main Footer with Version */}
      <footer className="w-full py-6 sm:py-8 px-4 sm:px-6 text-center bg-slate-50 border-t border-slate-200 text-slate-600 z-10">
        <div className="max-w-4xl mx-auto">
          <div className="mb-4 flex justify-center items-center gap-2">
            <img 
              src="/deped-logo.png" 
              alt="DepEd Logo" 
              className="h-10"
            />
            <h3 className="font-bold text-slate-700 text-base font-poppins">
              DepEd Imus City
            </h3>
          </div>
          
          <p className="text-sm font-poppins mb-2">
            For support inquiries: icts.imus@deped.gov.ph
          </p>
          
          <p className="text-sm font-poppins text-slate-400">
            © {new Date().getFullYear()} Department of Education - Imus City Division
          </p>

          {/* Version Display - Integrated into main footer */}
          <p className="text-xs sm:text-sm font-poppins text-slate-400 italic mt-2">
            version {appVersion}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;